const NIGHTSCOUT_USER_PASSPHRASE_URL = process.env.API_URL + '/nightscout/passphrase/';
const NIGHTSOCUT_OWN_PASSPHRASE_URL = process.env.API_URL + '/nightscout/user/changepassphrase';

const updateNightscoutUserPassphrase = (context, passphrase, id) => {
  return new Promise((resolve, reject) => {
    context.$http.post(NIGHTSCOUT_USER_PASSPHRASE_URL + id, passphrase)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const updateNightscoutOwnPassphrase = (context, passphrase) => {
  return new Promise((resolve, reject) => {
    context.$http.post(NIGHTSOCUT_OWN_PASSPHRASE_URL, passphrase)
      .then((data) => {
        resolve(data);
      }, error => {
        reject(error);
      });
  });
};

export default {
  updateNightscoutUserPassphrase,
  updateNightscoutOwnPassphrase
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/api/nightscout/index.js